import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";
import ErrorHandler from "../../../Helpers/Errors/ErrorHandler";
import TobaccoUsage from "../../Common/Helpers/TobaccoUsage";

export const GetFEXQuotes = (basicInfo, healthClass = null, coverageAmount, coverageMonthlyRate, setLoading, getIsSubscribed, setQuoteResults = null, setQuoteLogId = null, isQuotingCoverageAmount, skipErrorLog) => {
  const tobacco = TobaccoUsage(basicInfo.tobacco);
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  const getQuotes = () => {
    const queryParams = {
      birthdate: basicInfo.birthdate.replace(/\//g, "") || basicInfo.fakeBirthdate.replace(/\//g, ""),
      state: basicInfo.state,
      gender: basicInfo.gender,
      reverseQuote: !isQuotingCoverageAmount,
      faceAmount: coverageAmount,
      tobacco: tobacco,
      healthClass: "PP",
      oneClickAccountId: accountObj.account.oneClickAccountId,
      sessionId: accountObj.sessionId,
    };

    const queryParamsReverse = {
      birthdate: basicInfo.birthdate.replace(/\//g, "") || basicInfo.fakeBirthdate.replace(/\//g, ""),
      state: basicInfo.state,
      gender: basicInfo.gender,
      reverseQuote: !isQuotingCoverageAmount,
      projectionMonthlyRate: coverageMonthlyRate,
      tobacco: tobacco,
      healthClass: "PP",
      oneClickAccountId: accountObj.account.oneClickAccountId,
      sessionId: accountObj.sessionId,
    };

    fetch(`${covrServicesUrl}/api/FinalExpense/GetFinalExpenseQuotes`, {
      method: 'POST',
      headers: {
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(isQuotingCoverageAmount ? queryParams : queryParamsReverse),
    })
      .then((res) => res.json())
      .then((data) => {
        if (getIsSubscribed()) {
          if (data && data.quoteLogId && setQuoteLogId) {
            setQuoteLogId(data.quoteLogId)
          }
          const quoteResults = data && data.quoteResults;
          if (quoteResults && quoteResults.length) {
            if (setQuoteResults) {
              // Perform sort
              const sortedQuotes = quoteResults.sort((a, b) => a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore);
              setQuoteResults(healthClass ? sortedQuotes : sortedQuotes[0]);
            }
          } else {
            if (setQuoteResults) setQuoteResults([]);
          }
        }
      })
      .catch((error) => {
        if (getIsSubscribed()) {
          if(!skipErrorLog){
            ErrorHandler(error, setQuoteResults);
          }
         else{
          setQuoteResults([]);
         }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  if ((tobacco !== undefined)) {
    getQuotes();
  } else {
    setLoading(false);
  }
}
